import { Box } from "@mui/material";

import React from "react";

interface InfoProps {
    emoji: string;
    emojiAria: string;
    label: string;
    color: string;
    sx?: Record<string, number | string>;
}

const InfoBar = ({ emoji, label, color, emojiAria, sx = { mx: 0 } }: InfoProps) => (
    <Box component="div" sx={{ ...sx }}>
        <Box display="inline-block" bgcolor={color} px={1} py={1}>
            <div>
                <Box component="span" role="img" aria-label={emojiAria} mr={2}>
                    {emoji}
                </Box>
                {label}
            </div>
        </Box>
    </Box>
);

InfoBar.defaultProps = {
    sx: {}
};

export default InfoBar;
